import React from 'react'
import { TableContainer, Table, Tr, Th, Td } from '../../common'

const TableUserRole = ({ shownEntities, order, switchEnabled, ...rest }) => {
  return(
    <TableContainer>
      <Table>
        <thead>
        <tr>
          <Th></Th>
          <Th field='id' {...rest}>ID</Th>
          <Th field='name' {...rest}>Nome</Th>
        </tr>
        </thead>
        <tbody data-cy={'role-table'} >
        { shownEntities && shownEntities.map( priority =>
          <Tr key={priority.id} data-cy={`role-row-${priority.id}`} >
            <Td></Td>
            <Td dataCy={'id'} >{priority.id || '-'}</Td>
            <Td dataCy={'name'} >{priority.name || '-'}</Td>
          </Tr>
        )}
        </tbody>
      </Table>
    </TableContainer>
  )
}

export default TableUserRole